import { createReducer, on } from '@ngrx/store';

import { LocalDate } from '@fcom/core/utils';

import { SearchState } from '../../interfaces/store.interface';
import { SearchActions } from '../actions';

const today = LocalDate.now();

export const initialState: SearchState = {
  origin: null,
  destination: null,
  selectedDay: today,
  selectedMonth: {
    year: today.toDate().getFullYear(),
    month: today.toDate().getMonth() + 1,
  },
  directOnly: false,
};

const stateReducer = createReducer(
  initialState,
  on(SearchActions.setSearch, (state, newSearch) => ({
    ...state,
    ...newSearch,
  })),
  on(SearchActions.clearSearch, () => ({
    ...initialState,
  }))
);

export function reducer(state: SearchState, action: SearchActions.SearchActionsUnion): SearchState {
  return stateReducer(state, action);
}
